import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IllustrationBell = function IllustrationBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 140 140"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    stroke: "#FFA6B6",
    d: "m26.791 123.855-1.321-4.543-.002-.006c-.445-1.464-.27-3.337.55-5.577.82-2.233 2.26-4.781 4.274-7.557l.152-.21-.084-.245-18.327-53.582-.001-.003-.002-.008-.014-.045-.053-.182a25 25 0 0 1-.192-.716 39 39 0 0 1-.57-2.677 45 45 0 0 1-.684-9.076c.208-7.229 2.35-16.135 10.048-23.009l.311-.278-.217-.355c-1.426-2.333-.864-5.226 1.097-6.452 1.97-1.23 4.765-.524 6.323 1.683l.24.34.378-.174c9.554-4.399 18.635-2.689 25.36.147a44.4 44.4 0 0 1 8.048 4.453c.961.67 1.71 1.25 2.219 1.663a25 25 0 0 1 .721.608l.036.032.007.006.001.001.002.002 41.13 39.172.188.178.253-.05c3.196-.625 5.984-.897 8.288-.76 2.294.135 4.06.674 5.276 1.624l.119.118.011.01.011.01 3.773 3.355c-1.641-.429-3.589-.572-5.775-.465-3.853.189-8.533 1.159-13.769 2.82-10.475 3.321-23.247 9.43-36.218 17.702-12.902 8.204-23.747 17.187-31.147 25.271-3.698 4.041-6.548 7.872-8.36 11.28-1.045 1.963-1.759 3.812-2.08 5.495Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE5374",
    stroke: "#DE5374",
    d: "m87.268 111.334-.003.001c-13.753 8.867-27.281 15.209-38.014 18.288-5.37 1.54-10.01 2.255-13.618 2.078-3.622-.179-6.083-1.248-7.283-3.142l-.03-.047-.021-.022a1 1 0 0 1-.037-.102l-.002-.007a2 2 0 0 0-.074-.194 1 1 0 0 0-.067-.126 1 1 0 0 0-.09-.222l-.004-.006-.019-.039a.9.9 0 0 0-.048-.221 2.72 2.72 0 0 0-.048-.12l-.008-.019a.4.4 0 0 1-.034-.147v-.193l-.011-.052c-.453-2.101.208-4.891 1.954-8.215 1.738-3.308 4.511-7.068 8.159-11.073C45.263 99.748 56 90.82 68.776 82.652 81.76 74.345 94.454 68.28 104.81 65.007c5.18-1.636 9.756-2.568 13.483-2.74 3.743-.174 6.543.424 8.256 1.75l.039.03.044.021c.463.232.804.573 1.035 1.036l.011.022.013.02c1.166 1.859 1.076 4.522-.299 7.872-1.368 3.335-3.967 7.236-7.614 11.457-7.289 8.437-18.687 18.062-32.51 26.859Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    stroke: "#00204D",
    d: "M100.06 66.626c9.152-3.42 16.859-4.93 21.978-4.249.038 2.063-.809 4.641-2.504 7.612-1.798 3.152-4.517 6.689-8.016 10.432-6.997 7.484-17.072 15.748-29.008 23.357s-23.688 13.29-33.435 16.51c-4.875 1.611-9.234 2.601-12.856 2.913-3.412.295-6.111-.017-7.971-.922 1.56-4.858 6.177-11.169 13.114-18.021 7.108-7.02 16.595-14.555 27.555-21.606 10.96-7.05 21.772-12.525 31.143-16.026Z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "illustration-bell_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.068 128.966c-.14-.14-.28-.419-.28-.559 0 .14.14.419.28.559"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DE5374",
    d: "M28.068 128.966c-.14-.14-.28-.419-.28-.559 0 .14.14.419.28.559"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE5374",
    d: "m28.775 128.259.016.017-.021-.037q-.01-.023-.005-.009l.011.046a1 1 0 0 1 .012.131h-2c0 .312.125.591.193.727.084.167.21.371.38.539zm-1.987.148c0 .312.125.591.193.727.084.167.21.371.38.539l1.414-1.414.016.017-.021-.037q-.01-.023-.005-.009l.011.046a1 1 0 0 1 .012.131z",
    mask: "url(#illustration-bell_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-bell_svg__b)",
    d: "M27.368 127.147c0 .28.14.56.28.7-.14-.14-.28-.28-.28-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-bell_svg__c)",
    d: "m126.995 63.621 1.26 1.26c-.42-.42-.84-.98-1.26-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-bell_svg__d)",
    d: "M27.508 127.987c0 .139.14.279.14.419 0-.14 0-.28-.14-.419"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    stroke: "#34519F",
    d: "m66.96 83.78 2.656-1.699 3.745 5.8c-.476.217-.909.46-1.342.78a5.507 5.507 0 0 0-.89.616 31 31 0 0 0-.404.334zm4.34 21.944.005.006.004.006q.25.376.518.722a9.7 9.7 0 0 1-2.477-2.663c-2.665-4.264-1.872-9.727 1.58-13.067l1.654-1.24c.51-.383 1.025-.643 1.697-.912 2.168-.78 4.438-.883 6.527-.322a10.6 10.6 0 0 0-4.096.79l-.017.008-.017.008q-.174.087-.383.184c-.458.216-1.014.477-1.476.816-.318.165-.619.395-.89.616l-.3.246c-.179.15-.348.291-.525.424l-.02.016-.02.017c-3.96 3.668-4.684 9.672-1.763 14.345Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    stroke: "#34519F",
    d: "m83.63 106.996-.004.003c-2.635 1.712-5.8 1.996-8.73 1.087a11.8 11.8 0 0 1-2.751-2.898c-2.66-4.264-1.867-9.723 1.584-13.06l1.654-1.241c.51-.383 1.024-.643 1.695-.912 2.263-.796 4.77-.927 7.002-.161a11.8 11.8 0 0 1 2.758 2.905c3.063 4.8 1.599 11.206-3.209 14.277Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-bell_svg__e)",
    d: "M21.492 8.91c-2.24 1.4-2.8 4.618-1.26 7.136l8.256-5.317C26.668 8.21 23.59 7.371 21.49 8.91"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE5374",
    stroke: "#DE5374",
    d: "M30.512 10.417c8.884-3.411 17.247-1.742 23.545.913a44.4 44.4 0 0 1 8.048 4.453c.961.67 1.71 1.25 2.219 1.663a25 25 0 0 1 .721.608l.036.032.006.005.002.002 40.307 38.518c-11.049 2.426-25.943 8.946-41.077 18.763-11.966 7.585-22.078 15.833-29.146 23.385a263 263 0 0 0 8.516-14.434c3.347-6.134 6.699-12.95 9.215-19.591 2.514-6.632 4.209-13.127 4.209-18.604v-.002l-.5.002.5-.003v-.049l-.002-.053-.007-.288a35 35 0 0 0-.053-1.085 51 51 0 0 0-.402-3.867c-.455-3.204-1.355-7.502-3.142-11.863-3.407-8.314-10.064-16.904-22.995-18.505Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-bell_svg__f)",
    d: "M22.75 8.35c4.478 1.4-2.658 7.696-2.658 7.696l8.256-5.317C27.088 8.63 24.85 7.791 22.75 8.35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE5374",
    stroke: "#DE5374",
    d: "m27.652 10.583-4.474 2.881q.171-.225.332-.454c.62-.887 1.167-1.905 1.214-2.842.024-.487-.086-.97-.404-1.388l-.076-.093c1.294.063 2.537.703 3.408 1.896Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD7DF",
    stroke: "#FFD7DF",
    d: "M23.65 40.673c0 3.901-.543 7.412-1.407 9.93-.433 1.261-.937 2.246-1.472 2.906-.539.664-1.055.937-1.518.937s-.98-.273-1.518-.937c-.535-.66-1.04-1.645-1.472-2.906-.864-2.518-1.408-6.029-1.408-9.93s.544-7.412 1.408-9.93c.432-1.261.937-2.246 1.472-2.906.538-.663 1.054-.936 1.518-.936s.98.273 1.518.936c.535.66 1.039 1.645 1.472 2.906.864 2.518 1.407 6.029 1.407 9.93Z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-bell_svg__b",
    x1: 37.76,
    x2: 18.809,
    y1: 143.674,
    y2: 114.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878787",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-bell_svg__c",
    x1: 137.506,
    x2: 118.555,
    y1: 79.826,
    y2: 50.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878787",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-bell_svg__d",
    x1: 37.606,
    x2: 18.691,
    y1: 143.731,
    y2: 114.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878787",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-bell_svg__e",
    x1: 67.937,
    x2: 21.428,
    y1: 81.505,
    y2: 8.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#878787",
    stopOpacity: 0.878
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#878787",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-bell_svg__f",
    x1: 18.79,
    x2: 27.083,
    y1: 13.857,
    y2: 8.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878787",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878787"
  }))));
};